// extracted by mini-css-extract-plugin
export default {"category-onlypic":"slot-games-content_category-onlypic__tzCV-","category":"slot-games-content_category__LjXQp"};